import { render, staticRenderFns } from "./MinReleaseSchedules.vue?vue&type=template&id=22539432&"
import script from "./MinReleaseSchedules.vue?vue&type=script&lang=js&"
export * from "./MinReleaseSchedules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports